<template>
  <div>
    <v-app-bar dense max-height="96">
      <img
        src="/static/logo2.png"
        style="max-width: 100px"
        class="mt-12 ml-8"
      />
      <v-spacer />
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              class="mt-12"
              fab
              x-large
              @click="commented"
            >
              <v-icon>mdi-message-reply-text</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Comment") }}</span>
        </v-tooltip>
      </div>
      <div v-if="currentDocument.RequiresValidation">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="mt-12"
              color="green"
              elevation="10"
              fab
              x-large
              @click="validate"
              :loading="loadingActions"
            >
              <v-icon color="white">mdi-check-bold</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Validate") }}</span>
        </v-tooltip>
      </div>
      <div v-if="currentDocument.RequiresValidation">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="mt-12"
              color="error"
              elevation="10"
              fab
              x-large
              @click="reject"
              :loading="loadingActions"
            >
              <v-icon color="white">mdi-close-thick</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Refuse") }}</span>
        </v-tooltip>
      </div>
      <div v-if="currentDocument.RequiresSignature">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="mt-12"
              color="green"
              elevation="10"
              fab
              x-large
              @click="sign"
              :loading="signing"
            >
              <v-icon color="white" v-if="!signing">mdi-draw</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Sign") }}</span>
        </v-tooltip>
      </div>
      <template v-slot:extension>
        <v-tabs
          centered
          style="
            padding-left: 120px !important;
            padding-right: 120px !important;
          "
        >
          <v-tab
            v-for="(doc, i) in documentList"
            :key="doc.objectID"
            @click="loadDocument(doc)"
          >
            <v-icon large class="mr-1">mdi-file-document-outline</v-icon>
            #{{ i + 1 }}
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-content>
      <div>
        <v-row justify="center" align="center" v-if="loading">
          <div class="text-center">
            <div>
              <v-progress-circular
                class="my-4"
                :size="50"
                width="5"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <p class="display-1">{{ $t("Loading") }}...</p>
          </div>
        </v-row>
        <v-row justify="center" align="center" no-gutters v-if="hasAttachments">
          <v-col cols="4">
            <v-select
              clearable
              :label="$t('DocumentAttachments')"
              :items="currentDocument.Attachments"
              @change="loadAttachment"
              item-text="Description"
              item-value="Id"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="!loading" no-gutters>
          <v-col>
            <pdf-viewer :ref="viewerKey" :height="getHeight" />
            <div v-if="currentDocument.AllowDownload" @click="download">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mb-12"
                    v-on="on"
                    color="info"
                    elevation="10"
                    fab
                    x-large
                    bottom
                    right
                    absolute
                  >
                    <v-icon color="white">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("Download") }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-content>
    <app-core-footer />
    <v-dialog v-model="showInfoMessage" width="60%">
      <v-card>
        <v-card-text v-html="infoMessage"></v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCommentModal" width="60%">
      <v-card>
        <v-card-title class="pt-3">
          <span class="headline">{{ $t("Comment") }}</span>
        </v-card-title>
        <v-card-text>
          <tiptap-vuetify
            v-model="rejectComment.text"
            :extensions="extensions"
          />
        </v-card-text>
        <v-card-actions class="pt-0 pb-3 mt-3">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            @click.prevent="cancelReject()"
            >{{ $t("Close") }}
          </v-btn>
          <v-btn
            color="error"
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            @click.prevent="confirmReject()"
            >{{ $t("Refuse") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCommentExternalModal" width="60%">
      <v-card>
        <v-card-title class="pt-3">
          <span class="headline">{{ $t("Comment") }}</span>
        </v-card-title>
        <v-card-text>
          <tiptap-vuetify
            v-model="commentExternal.text"
            :extensions="extensions"
          />
        </v-card-text>
        <v-card-actions class="pt-0 pb-3 mt-3">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            @click.prevent="cancelCommentExternal()"
            >{{ $t("Close") }}
          </v-btn>
          <v-btn
            color="error"
            small
            class="pa-4 text-capitalize font-weight-regular display-1"
            @click.prevent="confirmCommentExternal()"
            :loading="loadingActions"
            >{{ $t("Save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PdfViewer from '@/components/document/PdfViewer';
import DistributionService from '@/services/DistributionsService';
import AppCoreFooter from '@/components/core/Footer';
import Utils from '@/ecm/common/Utils.js';
import Comment from '@/ecm/models/search/results/list/Comment';
import {
    TiptapVuetify,
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History,
} from 'tiptap-vuetify';

export default {
    components: {
        PdfViewer,
        AppCoreFooter,
        TiptapVuetify,
    },
    data() {
        return {
            distributionToken: '',
            viewerKey: 'externalPdfViewer',
            documentList: [],
            currentDocument: {},
            infoMessage: '',
            rejectComment: new Comment(),
            commentExternal: new Comment(),
            showInfoMessage: false,
            showCommentModal: false,
            loading: false,
            signing: false,
            loadingActions: false,
            extensions: [
                History,
                Blockquote,
                Link,
                Underline,
                Strike,
                Italic,
                ListItem,
                BulletList,
                OrderedList,
                [
                    Heading,
                    {
                        options: {
                            levels: [1, 2, 3],
                        },
                    },
                ],
                Bold,
                HorizontalRule,
                Paragraph,
                HardBreak,
            ],
            showCommentExternalModal: false,
        };
    },
    created() {
        this.distributionToken = this.$route.params.distribution_token;
        this.getDistributedDocuments();
    },
    computed: {
        viewerInstance() {
            return this.$refs[this.viewerKey];
        },
        hasAttachments() {
            return (
                this.currentDocument.Attachments &&
                this.currentDocument.Attachments.length > 0
            );
        },
        getHeight() {
            return window.innerHeight - 96 - 68 - (this.hasAttachments ? 70 : 0); //96px header, 68px footer, 24px padding, 70px attachment selector
        },
    },
    methods: {
        getDistributedDocuments() {
            this.loading = true;
            var self = this;
            DistributionService.getDistributedDocuments(this.distributionToken)
                .then((result) => {
                    self.documentList = result;
                    if (self.documentList) {
                        self.loadDocument(self.documentList[0]);
                        self.infoMessage = self.documentList[0].InfoMessage;
                        if (self.infoMessage) {
                            self.showInfoMessage = true;
                        }
                    }
                    self.loading = false;
                })
                .catch(() => {
                    self.loading = false;
                });
        },
        validate() {
            this.loadingActions = true;
            DistributionService.validate(this.distributionToken, this.currentDocument.ObjectID)
                .then((result) => {
                    this.currentDocument.RequiresValidation = false;
                })
                .finally(() => {
                    this.loadingActions = false;
                });
        },
        reject() {
            this.rejectComment = new Comment();
            this.showCommentModal = true;
        },
        cancelReject() {
            this.rejectComment = new Comment();
            this.showCommentModal = false;
        },
        commented() {
            this.rejectComment = new Comment();
            this.showCommentExternalModal = true;
        },
        cancelCommentExternal() {
            this.commentExternal = new Comment();
            this.showCommentExternalModal = false;
        },
        confirmReject() {
            if (!this.rejectComment.text) {
                Utils.toast.error(this.$t('CommentRequired'));
                return;
            }
            this.loadingActions = true;
            DistributionService.reject(this.distributionToken, this.currentDocument.ObjectID, this.rejectComment)
                .then((result) => {
                    this.currentDocument.RequiresValidation = false;
                    this.rejectComment = new Comment();
                    this.showCommentModal = false;
                })
                .finally(() => {
                    this.loadingActions = false;
                });
        },
        confirmCommentExternal() {
            if (!this.commentExternal.text) {
                Utils.toast.error(this.$t('CommentRequired'));
                return;
            }
            this.loadingActions = true;
            DistributionService.comment(this.distributionToken, this.currentDocument.ObjectID, this.commentExternal)
                .then(() => {
                    Utils.toast.success(this.$t('AddCommentSuccess'));
                    this.commentExternal = new Comment();
                    this.showCommentExternalModal = false;
                })
                .catch(() => {
                    Utils.toast.error(this.$t('AddCommentError'));
                })
                .finally(() => {
                    this.loadingActions = false;
                });
        },
        async sign() {
            this.signing = true;
            try {
                const redirectURL = await DistributionService.sign(
                    this.distributionToken,
                    this.currentDocument.ObjectID
                );
                window.location = redirectURL;
            } catch (error) {
                console.error('Error signing:', error);
            } finally {
                this.signing = false;
            }
        },
        download() {
            Utils.file.attachment.download(
                `distributions/download-document/${this.distributionToken}/${this.currentDocument.ObjectID}`
            );
        },
        loadDocument(document) {
            this.currentDocument = document;
            this.$nextTick(() => {
                var docURL = `${this.$store.getters['account/apiUrl']}/api/distributions/display-document/${this.distributionToken}/${document.ObjectID}`;
                const file = encodeURIComponent(docURL);
                this.viewerInstance.load(file);
            });
        },
        loadAttachment(attID) {
            if (!attID) {
                this.loadDocument(this.currentDocument);
                return;
            }
            this.$nextTick(() => {
                var docURL = `${this.$store.getters['account/apiUrl']}/api/distributions/display-document-attachment/${this.distributionToken}/${this.currentDocument.ObjectID}/${attID}`;
                const file = encodeURIComponent(docURL);
                this.viewerInstance.load(file);
            });
        },
    },
};
</script>
<style >
.v-toolbar__content {
  z-index: 9999 !important;
}
</style>
